import React from 'react';  // eslint-disable-line

const Messages = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="19" viewBox="0 0 23 19">
            <g fill="none" fillRule="evenodd" stroke={props.activeColor} strokeLinecap="round" strokeLinejoin="round">
                <path d="M1 1l11 9 10-9" />
                <path d="M1 1h21v17H1z" />
            </g>
        </svg>
    );
};

export default Messages;
